import React, { useState, useEffect } from 'react';
import { Form } from 'react-bootstrap';
import { MDBDataTable } from 'mdbreact';
import { useTranslation } from 'react-i18next';
import CheckboxInput from '../../../components/common/Checkbox';
import MasterPermissions from '../../../api/MasterPermissions';
import { PATIENTS_RIGHTS_COLUMN } from '../../../../constants/index';
import CustomClientError from '../../../errorhandling/CustomClientError';
import APIEndpoints from '../../../api/APIEndpoints';
import { axiosInstance } from '../../../../api/axios';
import { toast } from 'react-toastify';
import ToastMessage from '../../common/ToastMessage';
import { HttpSuccessCodes } from 'src/Admin/errorhandling/HttpErrorCodes';
import GenericButton from 'src/Components/GenericButton/GenericButton';
import './styles/hippa-rights.scss';
import HippaPatientRightSkeleton from './skeleton/HippaPatientRightSkeleton';

const HippaPatientRight = ({
  allowEmpViewMyInfo,
  allowRespPartyViewMyInfo,
  responsiblePartyInfo,
  serverErrorHipaa,
  selectedMember,
  employeeInfo,
}) => {
  const { t } = useTranslation();
  const data = { columns: PATIENTS_RIGHTS_COLUMN, rows: responsiblePartyInfo };
  const [respViewInfo, setRespViewInfo] = useState();
  const [dependentPermit, setDepenedentPermit] = useState();
  const [hippaRightsData, setHippaRightsData] = useState();
  const [isAPIFailed, setIsAPIFailed] = useState(false);
  const [prevSeqnceNumber, setPrevSeqnceNumber] = useState();
  const [loader, setLoader] = useState(false);
  const HippaRightsData = async () => {
    setLoader(true);
    const dependentSq =
      selectedMember?.mType === 'Employee'
        ? ''
        : '/depseqnumber/' + employeeInfo?.DepSequenceNumber;
    const params =
      selectedMember?.mType === 'Employee'
        ? '/memberid/' + employeeInfo?.MemberID
        : '/memberid/' + employeeInfo?.MemberID + dependentSq;
    try {
      const HippaRights = await axiosInstance.get(
        APIEndpoints.getHippaPermissionsRights() + params,
      );
      setPrevSeqnceNumber(employeeInfo?.DepSequenceNumber);
      setRespViewInfo(
        selectedMember.mType === 'Employee'
          ? HippaRights?.data?.Response?.ViewMyInfo === 'Y'
            ? true
            : false
          : HippaRights?.data?.Response?.PartyViewMyInfo === 'Y'
          ? true
          : false,
      );
      setDepenedentPermit(
        HippaRights?.data?.Response?.EmpViewMyInfo === 'Y' ? true : false,
      );
      setHippaRightsData(HippaRights?.data?.Response);
      setIsAPIFailed(false);
      setLoader(false);
      console.log('responseDependentsData >>>>>>>>>>>>  ::: ', HippaRights);
    } catch (e) {
      setIsAPIFailed(true);
      setLoader(false);
    }
  };

  const HippaRightsDataSubmit = async () => {
    const DependentJson = {
      Memberid: employeeInfo?.MemberID,
      DepSequenceNumber: employeeInfo?.DepSequenceNumber,
      PartyViewMyInfo: respViewInfo ? 'Y' : 'N',
      EmpViewMyInfo: dependentPermit ? 'Y' : 'N',
    };
    const EmployeeJson = {
      Memberid: employeeInfo?.MemberID,
      ViewMyInfo: respViewInfo ? 'Y' : 'N',
    };

    try {
      const HippaRights = await axiosInstance.put(
        APIEndpoints.updateHippaPermissionsRights(),
        selectedMember.mType === 'Employee' ? EmployeeJson : DependentJson,
      );
      console.log('responseDependentsData >>>>>>>>>>>>  ::: ', HippaRights);
      if (
        [
          HttpSuccessCodes.HTTP_SUCCESS_CODE_200,
          HttpSuccessCodes.HTTP_SUCCESS_CODE_201,
        ].includes(HippaRights.status)
      ) {
        toast.success(
          <ToastMessage
            type="success"
            subTitle={'Your preference(s) have been saved successfully!'}
          />,
        );
      }
    } catch (e) {
      toast.error(
        <ToastMessage
          type="error"
          subTitle={'Your preferences could not be updated! Try again later.'}
        />,
      );
      setRespViewInfo(
        selectedMember.mType === 'Employee'
          ? hippaRightsData?.ViewMyInfo === 'Y'
            ? true
            : false
          : hippaRightsData?.PartyViewMyInfo === 'Y'
          ? true
          : false,
      );
      setDepenedentPermit(
        hippaRightsData?.EmpViewMyInfo === 'Y' ? true : false,
      );
    }
  };
  useEffect(() => {
    if (selectedMember.mType === 'Employee') {
      employeeInfo?.MemberID && HippaRightsData();
    } else {
      employeeInfo?.MemberID &&
        employeeInfo?.DepSequenceNumber &&
        prevSeqnceNumber !== employeeInfo?.DepSequenceNumber &&
        HippaRightsData();
    }
  }, [
    employeeInfo?.MemberID,
    employeeInfo?.DepSequenceNumber,
    selectedMember?.ID,
  ]);

  return (
    <div className="my-profile-member-container">
      <div>
        <h2 className="row-title" tabIndex={0}>
          HIPAA Patient Right
        </h2>
        {!serverErrorHipaa ? (
          !loader ? (
            <>
              {isAPIFailed ? (
                <CustomClientError
                  ErrorHeading="Something went wrong with request!"
                  ErrorMessage="Please try again."
                />
              ) : (
                <>
                  <div className="patient-rights-details-container">
                    {allowEmpViewMyInfo && (
                      <Form.Group
                        className="form-block"
                        controlId="employeeAuthorizationFormGroup"
                      >
                        <CheckboxInput
                          //isDisabled={true}
                          id="employeeAuthorization"
                          name="employeeAuthorization"
                          checked={dependentPermit}
                          onChange={() => setDepenedentPermit(!dependentPermit)}
                          className="cursor-pointer employee-authorization-checkbox"
                          label={t(
                            'member.pages.my_profile.labels.employee_authorization',
                          )}
                        />
                      </Form.Group>
                    )}

                    {allowRespPartyViewMyInfo && (
                      <Form.Group
                        className="form-block"
                        controlId="responsiblePartyAuthorizationFormGroup"
                      >
                        <CheckboxInput
                          //isDisabled={true}
                          id="responsiblePartyAuthorization"
                          name="responsiblePartyAuthorization"
                          checked={respViewInfo}
                          onChange={() => setRespViewInfo(!respViewInfo)}
                          className="cursor-pointer responsible-authorization-checkbox"
                          label={t(
                            'member.pages.my_profile.labels.responsible_party_authorization',
                          )}
                        />
                      </Form.Group>
                    )}
                  </div>
                  <div>
                    {MasterPermissions.CheckPermission(
                      'View Responsible party Information',
                    ) && allowRespPartyViewMyInfo?.toLowerCase() == 'true' ? (
                      <>
                        <h2 className="row-title mt-5" tabIndex={0}>
                          Responsible Party Information
                        </h2>
                        <div className="responsible-party-details-container">
                          {responsiblePartyInfo.length ? (
                            <MDBDataTable
                              hover
                              data={data}
                              info={false}
                              paging={false}
                              searching={false}
                              id="responsible-party-mdb-table"
                            />
                          ) : (
                            //<span className="d-flex justify-content-center mb-4">{ t( 'member.pages.my_profile.patient_right.no_data' ) }</span>
                            <CustomClientError
                              /*ErrorHeading="Currently you do not have any HIPAA Patient Right information"*/
                              ErrorMessage="No Responsible parties"
                            />
                          )}
                        </div>
                      </>
                    ) : null}
                  </div>
                  <div>
                    <GenericButton
                      onClick={HippaRightsDataSubmit}
                      className="ml-1"
                    >
                      UPDATE
                    </GenericButton>
                  </div>
                </>
              )}
            </>
          ) : (
            <HippaPatientRightSkeleton />
          )
        ) : (
          <CustomClientError
            ErrorHeading="Something went wrong with request!"
            ErrorMessage="Please try again."
          />
        )}
      </div>
    </div>
  );
};

export default HippaPatientRight;
